import TranslationEditor from './TranslationEditor.jsx';
import './TranslationEditor.css';

export default TranslationEditor;
